import React from "react";

function SvgIcMapPoi043(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M23 23a2 2 0 012 2H9a2 2 0 012-2zM12.754 11.366c.67.477.473 1.004 1.12 1.301-.75 5.395 4.187 8.333 4.187 8.333h-4s-3.665-4.557-1.307-9.634zm2.13-3.67C17.061 6 20.41 6.645 21.83 9c-1.893-.62-4.524-.297-5.387.878 3.096-.328 3.424 3.939 2.51 6.565-.506-3.411-3.024-4.602-4.244-5.13-.922-.525-.042-.918-.647-1.282-3.895-.332-5.917 3.478-5.917 3.478C7.2 11.28 9.62 6.844 12.9 8.594 11.917 5.783 8 7 8 7c1.62-1.92 5.577-2.72 6.884.696z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi043;
